module.exports = __webpack_public_path__ + "img/bayer.8dd632d3.png";